<template>
    <a :class="btnClass" @click.prevent="openHelpBox"><slot><i class="bi bi-question-circle"></i></slot></a>
</template>

<script>

export default {
  props: {
    helpComponent: {
      required: false,
      default: ''
    },
    helpTitle: {
      required: false,
      default: ''
    },
    btnClass: {
      required: false,
      default: 'help-button'
    }
  },
  data () {
    return {
      helpOpen: false,
    }
  },
  computed: {
    // theClass () {
    //   return this.btnClass
    // }
  },
  methods: {
    openHelpBox () {
      this.helpOpen = true;
      this.emitter.emit("help-modal-open", this.helpOpen);
      this.emitter.emit("help-modal-data", {componentName: this.helpComponent, title: this.helpTitle});
    }
  }
}
</script>

<style lang="scss" scoped>
.help-button {
  display: inline-block;
  // width: 18px;
  // height: 18px;
  cursor: pointer;
  margin: 0 5px;
  padding: 0;
}



</style>